exports.bugsnagApiKey = '59322a1ea1c96206a359ca7781380db4'
exports.onError = (event) => {
    //Testing for our custom keys; this can be expanded.
    if (
        event.originalError &&
        event.originalError.hasOwnProperty('askNicelyMetadata')
    ) {
        event.addMetadata('askNicelyMetadata', {
            askNicelyMetadata: event.originalError.askNicelyMetadata,
        })
    }
}
